import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import Inspector from 'react-inspector';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Loader } from '../../../components/Loader';
import { CompanyPropertiesEditor } from '../components/CompanyPropertiesEditor';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class CompanyDetailsVarsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  render() {
    if (!this.props.company) return <Loader small />;
    return (
      <Container>
        {this.props.work ? (
          <Loader small />
        ) : (
          <VBox>
            <HBox flip={window.innerWidth <= 768}>
              <CompanyPropertiesEditor company={this.props.company} />
              <Inspector data={this.props.company} expandLevel={1}></Inspector>
            </HBox>
            {/* <hr />
            <Button small inline onClick={this.fromAutoTelex.bind(this)}>
              Uit Autotelex laden
            </Button> */}
          </VBox>
        )}
      </Container>
    );
  }
}

CompanyDetailsVarsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const CompanyDetailsVars = compose(
  withConnect,
  withRouter,
)(CompanyDetailsVarsComp);
